import { Box, type SxProps } from "@mui/material";
import { type Theme } from "@mui/material/styles";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { SetUpStripeAccountBanner } from "./SetUpStripeAccountBanner";

export interface SetUpStripeAccountBannerContainerProps {
  sourceUI: "account-tab" | "shifts-tab";
  sx?: SxProps<Theme>;
}

export function SetUpStripeAccountBannerContainer(props: SetUpStripeAccountBannerContainerProps) {
  const { sourceUI, sx } = props;

  const worker = useDefinedWorker();

  const isStripeOnboardingEnabled = useCbhFlag(CbhFeatureFlag.ENABLE_NEW_STRIPE_ONBOARDING, {
    defaultValue: false,
  });

  const isBannerShown =
    isStripeOnboardingEnabled &&
    // isOnboardingCompleted must be strictly equal to false
    // If it is undefined, then the user is on the old onboarding flow
    // If it is true, then the user has completed the onboarding flow so we don't show the banner
    worker.paymentAccountInfo?.isOnboardingCompleted === false;

  useLogEffect(
    APP_V2_USER_EVENTS.SET_UP_STRIPE_ACCOUNT_BANNER_SHOWN,
    {
      sourceUI,
    },
    { enabled: isBannerShown }
  );

  if (!isBannerShown) {
    return null;
  }

  return (
    <Box sx={sx}>
      <SetUpStripeAccountBanner
        onSetUpStripeAccountClick={() => {
          // noop for now
        }}
      />
    </Box>
  );
}
